<template>
  <yd-dialog
    :title="'打标'"
    :visible.sync="showLabel"
    append-to-body
    width="60%"
    v-loading="queryLoading"
  >
    <el-card style="margin: 18px 0" v-if="selectedUserArr && selectedUserArr.length === 1">
      <div class="selected-box">
        <div class="selected-title">已有标签：</div>
        <div class="selected-content">
          <el-tag
            class="label-tag"
            v-for="tag in existedTagArr"
            :key="tag.id"
            type="danger"
            closable
            @close="handleCloseExitTag(tag)"
          >
            {{ tag.tagName }}
          </el-tag>
        </div>
      </div>
    </el-card>
    <el-card>
      <el-input
        style="width: 280px"
        size="small"
        v-model.trim="keyWord"
        placeholder="请输入标签名称"
        @input="searchLabel"
        clearable
      >
        <el-button slot="append" icon="el-icon-search" @click="searchLabel" />
      </el-input>
      <div class="label-list">
        <div class="label-item" v-for="item in labelList" :key="item.id">
          <div class="label-item-title" @click="item.open = !item.open">
            <i class="el-icon-arrow-right up-down-btn" :class="{ rotate: item.open }"></i>
            {{ item.title }}
          </div>
          <el-collapse-transition>
            <div class="label-item-content" v-show="item.open">
              <el-tag
                class="label-tag"
                v-for="tag in item.labels"
                :key="tag.id"
                :type="tag.type"
                @click="handleSelectTag(tag)"
              >
                {{ tag.tagName }}
              </el-tag>
            </div>
          </el-collapse-transition>
        </div>
      </div>
    </el-card>
    <el-card style="margin: 18px 0">
      <div class="selected-box">
        <div class="selected-title">已选标签：</div>
        <div class="selected-content">
          <el-tag
            class="label-tag"
            v-for="tag in selectedTagArr"
            :key="tag.id"
            closable
            @close="handleCloseTag(tag)"
            type="danger"
          >
            {{ tag.tagName }}
          </el-tag>
        </div>
      </div>
    </el-card>
    <template #footer>
      <el-button @click="closeLabelDialog" size="mini">取 消</el-button>
      <el-button type="primary" @click="handleConfirm" size="mini" :loading="loading"
        >确 定</el-button
      >
    </template>
  </yd-dialog>
</template>

<script >
import { Message } from 'element-ui';
import { ref, inject, computed, watch } from '@vue/composition-api';
import { debounce } from 'lodash-es';
import { getTagManual, getCrmEnum } from '@/api/crm/label.js';
import { addTag, addTagBatch, getUserTag } from '@/api/crm/user.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const showLabel = inject('showLabel');
  const closeLabelDialog = inject('closeLabelDialog');
  const selectedUserArr = inject('selectedUserArr', []);
  // 查用户详情
  const getUserInfo = inject('getUserInfo');
  const search = inject('search');
  const logSearch = inject('logSearch');

  // 数据字典
  const dicOptions = ref({});
  const queryCrmDic = async () => {
    const {
      code,
      data
    } = await getCrmEnum();
    if (code !== 0) {
      return;
    }
    dicOptions.value = data;
  };
  // 字典转换
  const getLabelByCode = (code, dicArr) => {
    if (!Array.isArray(dicArr)) {
      return '';
    }
    const obj = dicArr.find(f => parseInt(f.value) === parseInt(code));
    if (obj) {
      return obj.label;
    }
    return '';
  };
  // 标签类型
  const tagTypeOptions = computed(() => {
    return dicOptions.value ? dicOptions.value.tagType : [];
  });

  // 标签数据转换
  const exchangeLabelTree = dataObj => {
    const treeObj = dataObj || {};
    const arr = [];
    for (const key in treeObj) {
      const obj = {
        id: key,
        open: true,
        title: '',
        labels: []
      };
      obj.title = getLabelByCode(key, tagTypeOptions.value);
      obj.labels = Array.isArray(treeObj[key]) ? treeObj[key] : [];
      arr.push(obj);
    }
    return arr;
  };

  // 查询标签树
  const allLabelList = ref([]);
  const labelList = ref([]);
  const queryLabelTree = async () => {
    const {
      code,
      data
    } = await getTagManual();
    if (code !== 0) {
      return;
    }
    allLabelList.value = exchangeLabelTree(data);
  };

  // 已有标签
  const existedTagArr = ref([]);
  // 查用户已有标签
  const queryUserTag = async phone => {
    const {
      code,
      data
    } = await getUserTag(phone);
    if (code !== 0 || !Array.isArray(data)) {
      return;
    }
    existedTagArr.value = data;
    // 渲染已有标签
    // if (!Array.isArray(allLabelList.value)) {
    //   return
    // }
    // 初始化标签树
    // allLabelList.value = allLabelList.value.map((item) => {
    //   if (Array.isArray(item.labels)) {
    //     item.labels = item.labels.map((obj) => {
    //       const f = existedTagArr.value.find((f) => f.id === obj.id)
    //       if (f) {
    //         obj.type = 'danger'
    //       } else {
    //         obj.type = ''
    //       }
    //       return obj
    //     })
    //   }
    //   return item
    // })
  };

  // 搜索关键字
  const keyWord = ref('');
  // 搜索标签
  const handleSearch = () => {
    if (!keyWord.value) {
      labelList.value = JSON.parse(JSON.stringify(allLabelList.value));
      return;
    }
    const arr = JSON.parse(JSON.stringify(allLabelList.value));
    labelList.value = arr.filter(item => {
      item.labels = item.labels.filter(f => new RegExp(keyWord.value.replace(/[|[\]\\]/gi, ''), 'ig').test(f.tagName));
      return item.labels.length > 0;
    });
  };
  const searchLabel = debounce(handleSearch, 500);

  // 选择的标签
  const handleSelectTag = tag => {
    allLabelList.value = allLabelList.value.map(item => {
      item.labels = item.labels.map(f => {
        if (f.id === tag.id) {
          f.type = f.type ? '' : 'danger';
        }
        return f;
      });
      return item;
    });
    handleSearch();
  };

  // 已选择的标签
  const selectedTagArr = computed(() => {
    const arr = [];
    allLabelList.value.forEach(item => {
      item.labels.forEach(f => {
        if (f.type) {
          arr.push(f);
        }
      });
    });
    return arr;
  });
  // 删除已选标签
  const handleCloseTag = tag => {
    allLabelList.value = allLabelList.value.map(item => {
      item.labels = item.labels.map(f => {
        if (f.id === tag.id) {
          f.type = '';
        }
        return f;
      });
      return item;
    });
    handleSearch();
  };
  // 删除已有标签
  const handleCloseExitTag = tag => {
    existedTagArr.value = existedTagArr.value.filter(item => item.id !== tag.id);
  };

  // 初始化页面
  const form = ref({});
  const queryLoading = ref(false);
  const initFormData = async () => {
    // 初始化表单
    form.value = {
      tagIds: [],
      userIds: []
    };
    form.value.userIds = selectedUserArr.value.map(item => {
      return item.userId;
    });
    try {
      queryLoading.value = true;
      // 查数据字典
      await queryCrmDic();
      // 初始化标签树
      await queryLabelTree();
      // 单个用户查已有标签
      if (selectedUserArr.value.length === 1) {
        const userInfo = selectedUserArr.value[0];
        await queryUserTag(userInfo.userId);
      }
    } catch (error) {
      console.log('error:', error);
    } finally {
      queryLoading.value = false;
    }

    // 初始化搜索框
    keyWord.value = '';
    handleSearch();
  };
  watch(showLabel, newVal => {
    if (newVal && selectedUserArr && selectedUserArr.value) {
      initFormData();
    }
  });

  // 数据提交
  const loading = ref(false);
  const handleConfirm = async () => {
    form.value.tagIds = selectedTagArr.value.map(item => {
      return item.id;
    });
    if (form.value.userIds && form.value.userIds.length > 1) {
      if (form.value.tagIds.length === 0) {
        Message.error('请选择标签');
        return;
      }
      // 批量用户打标  提交的标签都是新增的
      loading.value = true;
      const {
        code
      } = await addTagBatch(form.value);
      loading.value = false;
      if (code !== 0) {
        return;
      }
    } else {
      // 单个用户打标  提交当前用户所有标签
      const params = {};
      const existedTagIds = existedTagArr.value.map(item => {
        return item.id;
      });
      params.tagIds = Array.from(new Set([...existedTagIds, ...form.value.tagIds]));
      params.userId = form.value.userIds[0];
      if (params.tagIds.length === 0) {
        Message.error('请选择标签');
        return;
      }
      loading.value = true;
      const {
        code
      } = await addTag(params);
      loading.value = false;
      if (code !== 0) {
        return;
      }
    }
    Message.success('打标成功');
    closeLabelDialog();
    search && search();
    logSearch && logSearch();
    // 刷新用户详情
    const row = selectedUserArr.value && selectedUserArr.value.length > 0 ? selectedUserArr.value[0] : {};
    const phone = row.phone || row.mobilePhone;
    getUserInfo && getUserInfo(phone);
  };
  return {
    showLabel,
    closeLabelDialog,
    selectedUserArr,
    labelList,
    existedTagArr,
    keyWord,
    searchLabel,
    handleSelectTag,
    selectedTagArr,
    handleCloseTag,
    handleCloseExitTag,
    queryLoading,
    loading,
    handleConfirm
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  ::v-deep .el-card.is-always-shadow {
    border-radius: 4px !important;
    border: 1px solid #ebeef5 !important;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }

  .label-list {
    .label-item {
      margin: 18px 0;
      &-title {
        margin-bottom: 10px;
        width: 150px;
        cursor: pointer;
      }
      &-content {
        padding-left: 14px;
      }
    }
    .up-down-btn {
      position: relative;
      transform: rotate(0deg);
      transition: transform 350ms;
    }
    .rotate {
      transform: rotate(90deg);
    }
  }

  .label-tag {
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .selected-box {
    display: flex;
    .selected-title {
      width: 80px;
      height: 32px;
      display: flex;
      align-items: center;
    }
    .selected-content {
      flex: 1;
    }
  }
</style>
